export function removeDuplicate(array) {
    const r = [];
    array.forEach((item) => {
        const f = r.find((i) => i === item);
        if (f) return;
        r.push(item);
    });
    return r;
}
